var React = require('react');
var ReactNative = require('react-native');

var AppActions = require('./AppActions.js');
var LinkingManager = require('./wrappers/LinkingManager');
var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager');
var FadingView = require('./FadingView');
var FeedPlusView = require('./FeedPlusView');
var FeedPlusSideView = require('./FeedPlusSideView');
var OffsetView = require('./OffsetView');
var Animated = require('./wrappers/Animated');
var ReUpTabBar = require('./ReUpTabBar');
var AddToWalletButton = require('./AddToWalletButton');

const Icon = require('./wrappers/ReUpIcon');
var FEED_HEADER_HEIGHT = 80;

import Svg, {
    Path,
    G,
    Circle
} from './wrappers/react-native-svg-wrapper';

var Menu = require('./menu.js')
var FeedCard = require('./feedCard.js')
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpCountdown = require('./ReUpCountdown');
var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');
var MapView = require('./wrappers/react-native-maps-wrapper');
var ReUpButton = require('./ReUpButton');
var Meter = require('./Meter.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
  MKTextField
} = MK;

import ParallaxScrollView from './wrappers/react-native-parallax-scroll-view-wrapper';

var {
  View,
  WebView,
  ScrollView,
  StyleSheet,
  Platform,
  Image,
  TouchableHighlight,
  Dimensions,
  Keyboard,
  TouchableWithoutFeedback
} = ReactNative;

function findGetParameter(parameterName)
{
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item)
    {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });

  return result;
}

var PassHome = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    var maxWidth = 400;
    var maxHeight = 700;
    var width = Math.min(this.props.initialLayout.width-24, maxWidth);
    var height = Math.min(this.props.initialLayout.height-24, maxHeight);
    // var ratio = parseFloat(750 / 1334);
    // width = Math.min(width, height*ratio);
    // height = Math.min(height, width/ratio);
    var horizontalMargin = (this.props.initialLayout.width - width)/2;
    var verticalMargin = (this.props.initialLayout.height - height)/2;
    return {
      horizontalMargin,
      verticalMargin,
      rotationFront: new Animated.Value(90),
      rotationBack: new Animated.Value(90),

      isShowingFront: true,

      isShowingRegistration: false,
      isShowingFreeHome: false,
      isShowingHome: false,
      isShowingLogin: false,
      isShowingOnlyLogin: false,
      isShowingError: false,
      isShowingCFD: false,

      userName:null,
      phoneNumber:null,

      formOffset: new Animated.Value(0, "formOffset"),

      shouldDrawPage:[true,false],

      backFeatureData:this.props.appManager.getFeatureForName("MyCard"),
    }
  },

  _context: 0,
  componentDidMount : function()
  {
    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
    this.determineUser();
  },

  componentWillUnmount : function()
  {
    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.initialLayout !== 'undefined' )
    {
      var maxWidth = 400;
      var maxHeight = 700;
      var width = Math.min(newProps.initialLayout.width-24, maxWidth);
      var height = Math.min(newProps.initialLayout.height-24, maxHeight);
      // var ratio = parseFloat(750 / 1234);
      // width = Math.min(width, height*ratio);
      // height = Math.min(height, width/ratio);
      var horizontalMargin = (newProps.initialLayout.width - width)/2;
      var verticalMargin = (newProps.initialLayout.height - height)/2;

      this.setState({horizontalMargin, verticalMargin});
    }
  },

  determineUser: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();

    var userID = findGetParameter("userid");
    var hash = findGetParameter("hash");
    console.log("[passhome]", "URL INFO", userID, hash, appManager.currentUser())
    if( userID != null && hash != null )
    {
      // logged into correct account, proceed to pass home
      NetworkManager.getUser(appManager, userID, hash, (urlUser)=>
      {
        urlUser[ModelConstants.Password] = hash;
        NetworkManager.getLinkedUsers(appManager, userID, hash, (linkedUsers)=>
        {
          var emailUser = null;
          var phoneUser = null;
          for( var i = 0; i < linkedUsers.length; i++ )
          {
            if( linkedUsers[i]["Type"] == "email" || linkedUsers[i]["Type"] == "app" ) emailUser = linkedUsers[i];
            if( linkedUsers[i]["Type"] == "phone" ) phoneUser = linkedUsers[i];
          }
          if( phoneUser != null ) thisThing.setState({phoneNumber:locManager.localizedPhone(phoneUser["PhoneNumber"])});

          if( emailUser == null )
          {
            console.log("[passhome]", "no owner, so lets try to register");
            thisThing.setState({isShowingRegistration:true});
            setTimeout(()=>{thisThing.showFront()},400);
          }
          else
          {
            userID = emailUser[ModelConstants.UserID];
            hash = emailUser[ModelConstants.Hash];
            NetworkManager.getUser(appManager, userID, hash, (emailUser)=>
            {
              emailUser[ModelConstants.Password] = hash;
              appManager.setCurrentUser(emailUser, ()=>
              {
                this.setState({isShowingHome:true});
                setTimeout(()=>{thisThing.showFront()},400);
              })
            }, ()=>
            {
              var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
              var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
              thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
              setTimeout(()=>{thisThing.showFront()},400);
            }, ()=>
            {
              var errorTitleLocalized = thisThing.locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE");
              var errorBodyLocalized = thisThing.locManager.localizedStringForKey("NO_CONNECTION_STATEMENT");
              thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
              setTimeout(()=>{thisThing.showFront()},400);
            })
          }
        }, (errorData)=>
        {
          var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
          var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
          thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
          setTimeout(()=>{thisThing.showFront()},400);
          console.log("errorData",errorData)
        }, (errorData)=>
        {
          var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
          var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
          thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
          setTimeout(()=>{thisThing.showFront()},400);
          console.log("errorData",errorData)
        })
      }, ()=>
      {
        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
        thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
        setTimeout(()=>{thisThing.showFront()},400);
      }, ()=>
      {
        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE");
        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("NO_CONNECTION_STATEMENT");
        thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
        setTimeout(()=>{thisThing.showFront()},400);
      })
    }
    else if( appManager._isDemo )
    {
      NetworkManager.login(appManager, "kjregan10@gmail.com", "asdfwxyzabcd", (urlUser)=>
      {
        userID = urlUser[ModelConstants.UserID];
        hash = urlUser[ModelConstants.Hash];
        NetworkManager.getLinkedUsers(appManager, userID, hash, (linkedUsers)=>
        {
          var emailUser = null;
          var phoneUser = null;
          for( var i = 0; i < linkedUsers.length; i++ )
          {
            if( linkedUsers[i]["Type"] == "email" || linkedUsers[i]["Type"] == "app" ) emailUser = linkedUsers[i];
            if( linkedUsers[i]["Type"] == "phone" ) phoneUser = linkedUsers[i];
          }
          if( phoneUser != null ) thisThing.setState({phoneNumber:locManager.localizedPhone(phoneUser["PhoneNumber"])});

          if( emailUser == null )
          {
            console.log("[passhome]", "no owner, so lets try to register");
            thisThing.setState({isShowingRegistration:true});
            setTimeout(()=>{thisThing.showFront()},400);
          }
          else
          {
            userID = emailUser[ModelConstants.UserID];
            hash = emailUser[ModelConstants.Hash];
            NetworkManager.getUser(appManager, userID, hash, (emailUser)=>
            {
              emailUser[ModelConstants.Password] = hash;
              appManager.setCurrentUser(emailUser, ()=>
              {
                this.setState({isShowingHome:true});
                setTimeout(()=>{thisThing.showFront()},400);
              })
            }, ()=>
            {
              var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
              var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
              thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
              setTimeout(()=>{thisThing.showFront()},400);
            }, ()=>
            {
              var errorTitleLocalized = thisThing.locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE");
              var errorBodyLocalized = thisThing.locManager.localizedStringForKey("NO_CONNECTION_STATEMENT");
              thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
              setTimeout(()=>{thisThing.showFront()},400);
            })
          }
        }, (errorData)=>
        {
          var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
          var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
          thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
          setTimeout(()=>{thisThing.showFront()},400);
          console.log("errorData",errorData)
        }, (errorData)=>
        {
          var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
          var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
          thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
          setTimeout(()=>{thisThing.showFront()},400);
          console.log("errorData",errorData)
        })
      }, ()=>
      {
        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
        thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
        setTimeout(()=>{thisThing.showFront()},400);
      }, ()=>
      {
        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE");
        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("NO_CONNECTION_STATEMENT");
        thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
        setTimeout(()=>{thisThing.showFront()},400);
      })
    }
    else
    {
      // this.setState({isShowingRegistration:true});
      this.setState({isShowingCFD:true});
      setTimeout(()=>this.showFront(),200);
    }
  },

  _currentPageNum: 0,
  goToPage: function(pageNum, animated)
  {
    if( this._currentPageNum == pageNum ) return;
    this._currentPageNum = pageNum;

    if( typeof animated === 'undefined' ) animated = true;

    var newOffset = pageNum*(this.props.initialLayout.width - 2*this.state.horizontalMargin);

    var shouldDrawPage = this.state.shouldDrawPage;
    shouldDrawPage[pageNum] = true;
    this.setState({shouldDrawPage});

    var thisThing = this;
    if( this._pageContainer && this._pageContainer.scrollTo )
    {
      this._pageContainer.scrollTo({x:newOffset, animated, completion:()=>
      {
        thisThing.setState({shouldDrawPage:[pageNum == 0,pageNum == 1]});
      }});
    }
  },

  _showingFront : false,
  showFront : function()
  {
    if( this._showingFront ) return;
    this._showingFront = true;
    this.doUpdate();
    var thisThing = this;
    Animated.timing(
      thisThing.state.rotationBack,
      {
        toValue: 90,
        duration: 200
      }
    ).start(function()
    {
      thisThing.setState({isShowingFront:true});
      Animated.timing(
        thisThing.state.rotationFront,
        {
          toValue: 0,
          duration: 200
        }
      ).start(function()
      {

      });
    });
  },

  showBack : function(backFeatureData)
  {
    if( !this._showingFront ) return;
    this._showingFront = false;

    if( typeof backFeatureData !== 'undefined' ) this.setState({backFeatureData})
    else this.setState({backFeatureData:this.props.appManager.getFeatureForName("MyCard")})

    var thisThing = this;
    Animated.timing(
      thisThing.state.rotationFront,
      {
        toValue: 90,
        duration: 200
      }
    ).start(function()
    {
      thisThing.setState({isShowingFront:false});
      Animated.timing(
        thisThing.state.rotationBack,
        {
          toValue: 0,
          duration: 200
        }
      ).start(function()
      {

      });
    });
  },

  showNone : function()
  {
    this._showingFront = false;

    var thisThing = this;
    Animated.timing(
      thisThing.state.rotationBack,
      {
        toValue: 90,
        duration: 200
      }
    ).start(function()
    {

    });

    Animated.timing(
      thisThing.state.rotationFront,
      {
        toValue: 90,
        duration: 200
      }
    ).start(function()
    {
      thisThing.setState({isShowingFront:true});
    });
  },

  checkUserChanged : function()
  {
    var appManager = this.props.appManager;
    var loggedIn = this.props.appManager.isLoggedIn();
    if( !loggedIn && this.state.isShowingHome )
    {
      this._hasUpdated = false;
      this.goToPage(0);
      this.showNone();
      this.setState({
        isShowingFront: true,
        isShowingRegistration: false,
        isShowingFreeHome: false,
        isShowingHome: false,
        isShowingLogin: false,
        isShowingOnlyLogin: false,
        isShowingError: false});
      this.determineUser();
    }
  },

  _hasUpdated:false,
  doUpdate: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
    var {dataDependencies, customDependencies} = this.props.dataDependencyRetriever(feedFeatureNames);

    var hasRewards = false;
    for( var i = 0; i < dataDependencies.length; i++ )
    {
      if( dataDependencies[i] == "Rewards" )
      {
        hasRewards = true;
      }
    }
    if( !hasRewards ) dataDependencies.push("Rewards");

    if( !this._hasUpdated )
    {
      appManager.getDataTypes(thisThing.props.allDependencyKeys, function(data)
      {
        thisThing.didUpdate(data)
      })
    }
    this._hasUpdated = true;

    NetworkManager.update(appManager, dataDependencies, function(newData)
    {
      if( customDependencies.length <= 0 )
      {
        thisThing._shouldUpdateOnScrollAfterGoingDown = true;
        console.log("[setdata passhome]", newData)
        appManager.setData(newData,()=>
        {
          thisThing.didUpdate(newData)
        })
      }
      else
      {
        NetworkManager.retrieveCustomDataDependencies(appManager, customDependencies, newData, function(totalData)
        {
          appManager.setData(totalData,()=>
          {
            thisThing.didUpdate(totalData)
          })
        });
      }
    }, function(){});
  },

  didUpdate : function(data)
  {
    var thisThing = this;

    if( thisThing._feedPlusView == null || typeof thisThing._feedPlusView === 'undefined') return;

    if( typeof data !== 'undefined' && typeof data.Rewards !== 'undefined' && data.Rewards.length > 0 )
    {
      thisThing._feedPlusView.setRewards(data.Rewards)
    }
    else
    {
      thisThing.props.appManager.getDataType("Rewards",function(rewards)
      {
        if( typeof rewards !== 'undefined' )
        {
         thisThing._feedPlusView.setRewards(rewards)
        }
      })
    }
  },

  didCompleteRegistration: function()
  {
    var userID = findGetParameter("userid");
    var hash = findGetParameter("hash");
    var thisThing = this;
    var appManager = this.props.appManager;
    if( userID != null && hash != null )
    {
      NetworkManager.linkUsers(appManager, userID, hash, (data)=>
      {
        thisThing.showPreHome();
      },(data)=>
      {
        thisThing.showPreHome();
      },(data)=>
      {
        thisThing.showPreHome();
      });
    }
    else
    {
      thisThing.showPreHome();
    }
    // thisThing.setState({isShowingRegistration:false, isShowingLogin:false, isShowingHome:true});
    // Animated.timing(
    //   thisThing.state.rotationFront,
    //   {
    //     toValue: 90,
    //     duration: 200
    //   }
    // ).start(function()
    // {
    //   thisThing.setState({isShowingRegistration:false, isShowingLogin:false, isShowingHome:true});
    //   Animated.timing(
    //     thisThing.state.rotationFront,
    //     {
    //       toValue: 0,
    //       duration: 200
    //     }
    //   ).start(function()
    //   {
    //
    //   });
    // });
  },

  newAccountSelected: function()
  {
    this.setState({isShowingLogin:false, isShowingRegistration:true});
  },

  loginSelected: function()
  {
    this.setState({isShowingLogin:false, isShowingRegistration:true});
  },

  didCompleteLogin: function()
  {
    var userID = findGetParameter("userid");
    var hash = findGetParameter("hash");
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    if( userID != null && hash != null )
    {
      NetworkManager.getLinkedUsers(appManager, userID, hash, (linkedUsers)=>
      {
        var owner = null;
        for( var i = 0; i < linkedUsers.length; i++ )
        {
          if( linkedUsers[i]["Type"] == "app" )
          {
            owner = linkedUsers[i];
            break;
          }
        }
        if( owner != null && owner[ModelConstants.UserID] == appManager.currentUser()[ModelConstants.UserID] )
        {
          console.log("[passhome]", "logged in to correct account");
          thisThing.setState({isShowingHome:true, isShowingLogin:false, isShowingRegistration:false, isShowingOnlyLogin:false, isShowingError:false});
          thisThing.doUpdate();
        }
        else
        {
          console.log("[passhome]", "could not find owner or is isn't the same");
          NetworkManager.linkUsers(appManager, userID, hash, (data)=>
          {
            thisThing.showPreHome();
          },(errorData)=>
          {
            console.log("[passhome]", "account already linked 4", errorData);
            var errorTitleLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_TITLE");
            var errorBodyLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_BODY");
            thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
          },(errorData)=>
          {
            console.log("[passhome]", "account already linked 4", errorData);
            var errorTitleLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_TITLE");
            var errorBodyLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_BODY");
            thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
          });
        }

      },(errorData)=>
      {
        console.log("[passhome]", "account already linked 4", errorData);
        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_TITLE");
        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_BODY");
        thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
      },(errorData)=>
      {
        console.log("[passhome]", "account already linked 4", errorData);
        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_TITLE");
        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_BODY");
        thisThing.setState({isShowingError:true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized});
      });
    }
    else
    {
      thisThing.showPreHome();
    }
  },

  showPreHome: function()
  {
    // disabling prehome for now
    // this.goToPage(1);
    this.setState({isShowingHome:true, isShowingLogin:false, isShowingRegistration:false, isShowingOnlyLogin:false, isShowingError:false});
    this.doUpdate();
  },

  storeFocus: function()
  {
    console.log("storeFocus");
    if( this._focusStore ) this._focusStore.focus();
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();

    var bgImage = this.props.appManager.absoluteResourceForPath("Feed" + '/' + this.props.featureData.bgImage);

    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor",.6);

    // var myCardFeatureData = appManager.getFeatureForName("MyCard");
    var simpleCreateUser = appManager.getFeatureForName("SimpleCreateUser");
    var simpleLogin = appManager.getFeatureForName("SimpleLogin");
    var simpleCFDFeatureData = appManager.getFeatureForName("SimpleCFD");

    var didCompleteRegistration = this.didCompleteRegistration;
    var showBack = this.showBack;
    var newAccountSelected = ()=>{thisThing.newAccountSelected(thisThing)};
    var didCompleteLogin = ()=>{thisThing.didCompleteLogin(thisThing)};

    var iconImageName = appManager.absoluteResourceForPath('App/iTunesArtwork.png');
    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");

    var stripHeight = 120;

    var addedBackStyle = {};
    if( Platform.OS == 'web' ) addedBackStyle.height = "calc(100% - 60px)";

    var layout = {width:thisThing.props.initialLayout.width - 2*thisThing.state.horizontalMargin, height:thisThing.props.initialLayout.height-40-stripHeight-(2*thisThing.state.verticalMargin)};

    return <View style={[styles.container, {backgroundColor:generalColor, height:this.props.initialLayout.height, width:this.props.initialLayout.width}]}>
      <BlurView ref="blurView" blurType="light" initialOpacity={0} style={{position:'absolute', left:0, right:0, top:0, bottom:0}} imageName={bgImage} imageKey={appManager.getImageKey("bg")} />
      <MKTextField ref={(a)=>this._focusStore = a} style={{display:'none'}} />
      <Animated.View style={
      {
        display:this.state.isShowingFront ? 'block' : 'none',
        transform: [{ rotateY: this.state.rotationFront}],
        flexDirection:'column', alignSelf:'stretch', flex:1, marginLeft:this.state.horizontalMargin, marginRight:this.state.horizontalMargin, marginTop:this.state.verticalMargin, marginBottom:this.state.verticalMargin, borderRadius:20, backgroundColor:generalColor,
        overflow:'hidden'
      }}>
      {
        this.state.isShowingOnlyLogin ?
          <View key="onlylogincontainer" style={{marginLeft:0, height:thisThing.props.initialLayout.height-(2*this.state.verticalMargin), alignSelf:'stretch', flexDirection:'row'}}>
            <View style={{width:thisThing.props.initialLayout.width - 2*this.state.horizontalMargin, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}}>
              {appActions.featureForData(simpleLogin, {width:thisThing.props.initialLayout.width - 2*this.state.horizontalMargin, height:thisThing.props.initialLayout.height-(2*this.state.verticalMargin)}, appManager, {didCompleteRegistration, showBack, newAccountSelected, didCompleteLogin, userName:this.state.userName, phoneNumber:this.state.phoneNumber})}
            </View>
          </View>
        : null
      }
      {
        this.state.isShowingError ?
          <View style={{flex:1, flexDirection:'column', alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
            <ReUpText appManager={appManager} isTitle={true} style={{textAlign:'center', margin:10}}>
            {this.state.errorTitle}
            </ReUpText>
            <ReUpText appManager={appManager} style={{textAlign:'center', margin:10}}>
            {this.state.errorBody}
            </ReUpText>
          </View>
        : null
      }
      {
        this.state.isShowingRegistration || this.state.isShowingLogin ?
          <OffsetView ref={(a)=>this._pageContainer = a} key="reglogincontainer" horizontal={true} style={{height:thisThing.props.initialLayout.height-(2*this.state.verticalMargin), alignSelf:'stretch', height:this.props.initialLayout.height,flexDirection:'row', alignItems:'stretch'}}>
          {
            this.state.shouldDrawPage[0] ?
            <View style={{width:thisThing.props.initialLayout.width - 2*this.state.horizontalMargin, height:thisThing.props.initialLayout.height-(2*this.state.verticalMargin),flexDirection:'column', justifyContent:'center', alignItems:'stretch'}}>
              <View style={{height:stripHeight, backgroundColor:headerIconColor}}>
                <Image style={{width:'100%', height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
                <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
                  <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
                </View>
              </View>
              <View style={{height:thisThing.props.initialLayout.height-stripHeight-(2*this.state.verticalMargin), alignSelf:'stretch', overflow:'hidden'}}>
              {appActions.featureForData(simpleCreateUser, layout, appManager, {didCompleteRegistration, showBack, newAccountSelected, didCompleteLogin, storeFocus:thisThing.storeFocus})}
              </View>
            </View>
            :
            <View style={{width:thisThing.props.initialLayout.width - 2*this.state.horizontalMargin, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}} />
          }
          {
            this.state.shouldDrawPage[1] ?
            <View style={{width:thisThing.props.initialLayout.width - 2*this.state.horizontalMargin, height:thisThing.props.initialLayout.height-(2*this.state.verticalMargin), flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
              <View style={{alignSelf:'center', margin:20}}>
                <Image
                  style={{width:200, height:200}}
                  resizeMode={"contain"}
                  source={{uri: iconImageName}}>
                </Image>
              </View>
              {Platform.OS == "web" ? <AddToWalletButton appManager={appManager} style={{margin:10, width:140, height:44}} /> : null}
              <ReUpButton appManager={appManager} isSecondary={true} style={{margin:0, width:140}} text={locManager.localizedStringForKey("MORE_LABEL")}
                onPress={()=>{this.setState({isShowingHome:true, isShowingLogin:false, isShowingRegistration:false, isShowingOnlyLogin:false, isShowingError:false}); thisThing.doUpdate(); }} />
            </View>
            :
            <View style={{width:thisThing.props.initialLayout.width - 2*this.state.horizontalMargin, flexDirection:'column', justifyContent:'center', alignItems:'center'}} />
          }
          </OffsetView>
        : null
      }
      {
        this.state.isShowingHome ?
          <FeedPlusView key="feedPlusView" ref={(a)=>{if( a != null ) thisThing._feedPlusView = a}}
            style={{flex:1, alignSelf:'stretch', height:this.props.initialLayout.height-(2*this.state.verticalMargin)}}
            upArrowSelected={()=>{thisThing.scrollUp()}}
            flipSelected={(featureData)=>{thisThing.showBack(featureData)}}
            appManager={appManager} appActions={appActions}  />
        : null
      }
      {
        this.state.isShowingCFD ?
          this.props.featureBuilder.featureForData(simpleCFDFeatureData, {width:this.props.initialLayout.width - 2*this.state.horizontalMargin, height:this.props.initialLayout.height-(2*this.state.verticalMargin)}, this.props.appManager)
        : null
      }
      </Animated.View>
      <Animated.View style={
        {
          display:this.state.isShowingFront ? 'none' : 'block',
          flexDirection:'column',
          transform: [{ rotateY: this.state.rotationBack}],
          alignSelf:'stretch', flex:1, marginLeft:this.state.horizontalMargin, marginRight:this.state.horizontalMargin, marginTop:this.state.verticalMargin, marginBottom:this.state.verticalMargin, borderRadius:20, backgroundColor:headerColor,
          alignItems:'stretch',
          overflow:'hidden'
        }}>
        <View style={{height:60, flexDirection:'row', alignItems:'stretch', justifyContent:'center'}}>
          <View style={{width:60, justifyContent:'center', alignItems:'center'}}>
            <ReUpIconButton appManager={appManager} iconName={"angle-left"} onPress={()=>this.showFront()} type={2} />
          </View>
          <View style={{flex:1, justifyContent:'center', alignItems:'center'}}>
            <ReUpText appManager={appManager} isTitle={true} style={{color:headerTitleColor, textAlign:'center'}}>
            {this.state.backFeatureData.data.title}
            </ReUpText>
          </View>
          <View style={{width:60}}>
          </View>
        </View>
        <View style={[{flex:1}, addedBackStyle]}>
        {appManager.isLoggedIn() ? this.props.featureBuilder.featureForData(this.state.backFeatureData, {width:this.props.initialLayout.width - 2*this.state.horizontalMargin, height:this.props.initialLayout.height-60-(2*this.state.verticalMargin)}, this.props.appManager) : null}
        </View>
      </Animated.View>
    </View>;
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
    backgroundColor:'red'
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  feedHeader: {
    height:FEED_HEADER_HEIGHT,
    flexDirection:'row'
  },
  feedHeaderLeftContainer: {
    padding:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    alignItems:'center',
    justifyContent:'center',
  },
  profileImage: {
    height:FEED_HEADER_HEIGHT - 16,
    width:FEED_HEADER_HEIGHT - 16,
    borderRadius:(FEED_HEADER_HEIGHT - 16)/2,
    borderWidth:2,
    borderColor:'black',
    justifyContent:'center',
  },
  profileImageText: {
    textAlign:'center',
    fontSize:(FEED_HEADER_HEIGHT - 20)/2,
    fontWeight:'bold',
    backgroundColor:'transparent'
  },
  feedHeaderCenterContainer: {
    height:FEED_HEADER_HEIGHT,
    paddingVertical:10,
    flex:1,
    justifyContent:'space-between',
  },

  feedHeaderRightContainer: {
    paddingVertical:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    justifyContent:'space-between',
    alignItems:'center',
  },
  feedHeaderInfo: {
    fontWeight:'bold'
  },
})
PassHome.dataDependencies = ["Users", "Rewards"];

module.exports = PassHome;



// WEBPACK FOOTER //
// ./src/PassHome.js